import SuperFetch from "./superFetch";

export const getMobileOtp = async (mobileNumber) => {
    let data = {
        mobileNumber
    }
    let response = await SuperFetch('/api/send/otp/mobile', 'post', data)

    return response 
}

export const getEmailOtp = async (email) => {
    let data = {
        email
    }
    let response = await SuperFetch('/api/send/otp/email', 'post', data)

    return response 
}

